// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__1JmYy text_truncates__DIE7P"};